export const PROPERTY_FLYER_TEMPLATES = [
    {
        id: "new-listing-grand",
        name: "Grand Showcase",
        useCase: "Hero Layout",
        desc: "A clean luxury base with one dominant image and elegant spacing.",
        badge: "Property Showcase",
        cta: "Schedule Your Private Tour",
        layout: "hero-top",
        theme: "light-luxury",
        accentColor: "#0f766e"
    },
    {
        id: "just-listed-editorial",
        name: "Editorial Contrast",
        useCase: "Two-Hero Layout",
        desc: "A bold side-by-side presentation with darker editorial styling.",
        badge: "Signature Property",
        cta: "Request the Full Property Packet",
        layout: "split-editorial",
        theme: "noir-editorial",
        accentColor: "#c2410c"
    },
    {
        id: "open-house-weekend",
        name: "Sunlit Feature",
        useCase: "Hero + Detail",
        desc: "Bright and polished with a clear property information block.",
        badge: "Beautifully Staged",
        cta: "Join Us This Weekend",
        layout: "event-focus",
        theme: "sunlit-open-house",
        accentColor: "#ea580c"
    },
    {
        id: "open-house-twilight",
        name: "Twilight Luxe",
        useCase: "Dark Hero Layout",
        desc: "A darker luxury flyer for modern homes and evening mood.",
        badge: "Luxury Presentation",
        cta: "Reserve Your Showing Window",
        layout: "hero-top",
        theme: "midnight-glow",
        accentColor: "#8b5cf6"
    },
    {
        id: "coming-soon-teaser",
        name: "Quiet Minimal",
        useCase: "Minimal Layout",
        desc: "Restrained and spacious with one strong image and supporting detail.",
        badge: "Curated Property",
        cta: "Get Early Access",
        layout: "minimal-poster",
        theme: "soft-minimal",
        accentColor: "#475569"
    },
    {
        id: "luxury-estate-signature",
        name: "Estate Signature",
        useCase: "Luxury Mosaic",
        desc: "Black and platinum styling with a premium gallery-like composition.",
        badge: "Estate Collection",
        cta: "Book a Private Estate Tour",
        layout: "mosaic-premium",
        theme: "platinum-noir",
        accentColor: "#d4d4d8"
    },
    {
        id: "modern-home-showcase",
        name: "Architectural Modern",
        useCase: "Modern Editorial",
        desc: "Sharp typography and clean lines for contemporary listings.",
        badge: "Design Forward",
        cta: "See the Full Gallery",
        layout: "split-editorial",
        theme: "architectural-modern",
        accentColor: "#0f172a"
    },
    {
        id: "family-home-warmth",
        name: "Warm Welcome",
        useCase: "Balanced Layout",
        desc: "Soft warmth and approachable polish with a strong hero image.",
        badge: "Move-In Ready",
        cta: "Plan Your Family Tour",
        layout: "feature-stack",
        theme: "warm-family",
        accentColor: "#b45309"
    },
    {
        id: "price-improvement-bold",
        name: "Bold Spotlight",
        useCase: "Feature Layout",
        desc: "A vivid, high-contrast property sheet with crisp hierarchy.",
        badge: "Featured Home",
        cta: "Act Before It's Gone",
        layout: "event-focus",
        theme: "signal-red",
        accentColor: "#dc2626"
    },
    {
        id: "broker-open-network",
        name: "Broker Blue",
        useCase: "Dual Hero Layout",
        desc: "Professional and polished with side-by-side feature imagery.",
        badge: "Professional Presentation",
        cta: "Invite Your Buyers",
        layout: "dual-column",
        theme: "broker-blue",
        accentColor: "#2563eb"
    },
    {
        id: "waterfront-dreamscape",
        name: "Coastal Dreamscape",
        useCase: "Coastal Layout",
        desc: "Airy and elevated with a view-first hero presentation.",
        badge: "Coastal Living",
        cta: "Experience the View In Person",
        layout: "hero-top",
        theme: "coastal-breeze",
        accentColor: "#0891b2"
    },
    {
        id: "urban-condo-pulse",
        name: "City Pulse",
        useCase: "Urban Minimal",
        desc: "Compact, sleek, and modern for design-forward city listings.",
        badge: "City Living",
        cta: "Schedule a Downtown Tour",
        layout: "minimal-poster",
        theme: "city-night",
        accentColor: "#7c3aed"
    },
    {
        id: "townhome-clean-lines",
        name: "Clean Lines",
        useCase: "Structured Layout",
        desc: "Crisp and efficient with a modern property-sheet feel.",
        badge: "Stylish Home",
        cta: "Request a Walkthrough",
        layout: "feature-stack",
        theme: "stone-minimal",
        accentColor: "#334155"
    },
    {
        id: "investment-spotlight",
        name: "Capital Spotlight",
        useCase: "Dual Showcase",
        desc: "Structured, clean, and number-friendly without losing style.",
        badge: "Property Overview",
        cta: "Request Pro Forma Details",
        layout: "dual-column",
        theme: "capital-green",
        accentColor: "#15803d"
    },
    {
        id: "historic-charm",
        name: "Heritage Charm",
        useCase: "Classic Layout",
        desc: "Old-world warmth with graceful typography and classic spacing.",
        badge: "Timeless Character",
        cta: "Tour This Historic Residence",
        layout: "hero-top",
        theme: "heritage-warmth",
        accentColor: "#92400e"
    },
    {
        id: "ranch-retreat",
        name: "Earth Retreat",
        useCase: "Natural Mosaic",
        desc: "Grounded natural tones for lifestyle and retreat properties.",
        badge: "Land + Lifestyle",
        cta: "Explore the Property",
        layout: "mosaic-premium",
        theme: "earth-retreat",
        accentColor: "#3f6212"
    },
    {
        id: "weekend-tour-guide",
        name: "Rose Feature",
        useCase: "Bright Feature Layout",
        desc: "A brighter property sheet with easy scanning and clean balance.",
        badge: "Featured Property",
        cta: "Stop By This Weekend",
        layout: "event-focus",
        theme: "weekend-sunrise",
        accentColor: "#db2777"
    },
    {
        id: "luxury-penthouse-noir",
        name: "Penthouse Noir",
        useCase: "Luxury Editorial",
        desc: "Cinematic, ultra-dark, and premium for top-end presentations.",
        badge: "Private Collection",
        cta: "Arrange a Private Showing",
        layout: "split-editorial",
        theme: "penthouse-noir",
        accentColor: "#e2e8f0"
    },
    {
        id: "agent-sphere-social",
        name: "Lifestyle Rose",
        useCase: "Soft Editorial",
        desc: "A softer, more lifestyle-led base flyer with gentle contrast.",
        badge: "Now Available",
        cta: "Share With Someone Looking",
        layout: "feature-stack",
        theme: "lifestyle-rose",
        accentColor: "#be185d"
    },
    {
        id: "seller-preview-pitch",
        name: "Executive Cream",
        useCase: "Refined Layout",
        desc: "Refined and timeless with a presentation-ready luxury tone.",
        badge: "Refined Property",
        cta: "See How We Launch Listings",
        layout: "dual-column",
        theme: "executive-cream",
        accentColor: "#7c2d12"
    }
];

export const DEFAULT_PROPERTY_FLYER_TEMPLATE = PROPERTY_FLYER_TEMPLATES[0].id;
